import classNames from 'classnames';
import { FC } from 'react';

import Text, { TextProps } from '../Text';

// Component Definition
const Heading4: FC<TextProps> = props => (
  <Text
    as="h4"
    fontSize="heading4"
    {...props}
    className={classNames(props.className, 'text_heading4')}
  />
);

export default Heading4;
